<template>
  <div>
    <hr />
    <Filters @paginate="handleFilters" :loading="loading" />
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length == 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <div class="text-right mb-2" v-show="data.length > 0">
        <confirmation-dialog
          headerClass="modal-header-info"
          :loading="loadingExecute"
          :disabled="loadingExecute || selectedIds.length == 0"
          message-title="FINALIZAR?"
          message-body="Deseja realmente alterar para FATURADO?"
          open-class="btn-notcertified"
          open-left-icon="fa-check"
          open-text="FINALIZAR FATURAMENTO(S) PENDENTE(S) SELECIONADO(S)"
          @yes="execute"
        />
      </div>
      <v-data-table
        dense
        v-model="selected"
        show-select
        v-show="data.length > 0"
        :headers="headers"
        :items="data"
        :footer-props="{
          'items-per-page-options': [25, 50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
      >
        <template v-slot:[`item.status`]="{ item }">
          <small>FATURAMENTO PENDENTE</small>
          <v-icon class="ml-2" small color="orange">
            mdi-information-outline
          </v-icon>
          <input type="hidden" :value="item.status" />
        </template>
        <template v-slot:[`item.plan`]="{ item }">
          {{ handleType(item.resident_has_accommodation_type) }}
        </template>
        <template v-slot:[`item.information`]="{ item }">
          <p
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">VALOR DA DIÁRIA:</span>
            <strong>{{
              formatReal(item.resident_has_accommodation_value)
            }}</strong>
          </p>
          <div
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">QUANTIDADE DE DIÁRIAS:</span>
            <strong>{{ item.resident_has_accommodation_daily_amount }}</strong>
          </div>
          <p
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">TOTAL DO PERÍODO:</span>
            <strong>{{ formatReal(item.value) }}</strong>
          </p>
        </template>
        <template v-slot:[`item.due_date`]="{ item }">
          {{ formatDate(item.due_date, false) }}
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{ formatReal(item.value) }}
        </template>
        <template v-slot:[`item.note`]="{ item }">
          {{ item.note }}
        </template>
      </v-data-table>
      <div class="text-right" v-show="data.length > 0">
        <confirmation-dialog
          headerClass="modal-header-info"
          :loading="loadingExecute"
          :disabled="loadingExecute || selectedIds.length == 0"
          message-title="FINALIZAR?"
          message-body="Deseja realmente alterar para FATURADO?"
          open-class="btn-notcertified"
          open-left-icon="fa-check"
          open-text="FINALIZAR FATURAMENTO(S) PENDENTE(S) SELECIONADO(S)"
          @yes="execute"
        />
      </div>
    </b-overlay>
    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";

import Filters from "../../Components/Filters.vue";

import api from "../../../services/api";

import { formatDate, formatReal } from "../../../lib/format";

import toast from "../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "Invoincing",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    Filters,
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      month: moment().format("YYYY-MM"),
      dayMonthYear: "month",

      selectedIds: [],
      selected: [],

      status: 1,

      data: [],

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "PLANO", value: "plan", sortable: false },
        { text: "INFORMAÇÕES", value: "information", sortable: false },
        { text: "VENCIMENTO", value: "due_date", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "OBSERVAÇÃO", value: "note", sortable: false },
      ],

      items: [],

      loading: false,
      loadingExecute: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },

    selected() {
      this.selectedIds = this.selected.map((select) => select.id);
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    formatReal,
    moment,

    handleFilters(filters) {
      let { month, dayMonthYear } = filters;

      this.month = month;
      this.dayMonthYear = dayMonthYear;

      this.paginate();
    },

    handleType(type) {
      return (
        {
          DIARIA: "DIÁRIA",
          MENSAL: "MENSAL",
        }[type] || "NÃO ENCONTRADO"
      );
    },

    retrieve() {
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, status, month, dayMonthYear } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          status,
          page,
          itemsPerPage,
          month,
          dayMonthYear,
        };

        const response = await api.get("/rest-home/resident-accommodations", {
          params,
        });

        const { data, total } = response.data;

        this.data = data;
        this.total = total;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loadingExecute = true;

        const { resident_id, selectedIds } = this;

        let params = {
          resident_id,
          items: selectedIds,
        };

        const response = await api.post(
          "/rest-home/resident-accommodation/pending-billing",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.selectedIds = [];
          this.paginate();
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingExecute = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
